import * as React from 'react';
import { useState } from 'react';
import SimpleTable from 'src/components/common/SimpleTable/SimpleTable';
import classNames from 'classnames';
import styles from '../../../assets/case-component-tab.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import ColumnForm from './ColumnForm';
import DeleteInternalAction from './DeleteInternalAction';

import { Paginated } from 'src/services/api-handlers/pagination';

import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';

import ModalComponent from 'src/components/modals/ModalComponent';

import { changeToZeroMoment } from 'src/helpers/timeHelpers';

import { IProvider } from 'src/types/provider';
import { IInternal } from 'src/types/internal';
import GeneralEnumService from 'src/enumerables/general-enum';
import user from 'src/services/user-auth';
import UserRole from 'src/enumerables/user-role';
import MobileCard from 'src/components/mobile/MobileCard';
import { numberWithCommas } from '../../../../../../../../../helpers/format';

export interface StateProps {}
export interface DispatchProps {}

export interface OwnProps {
    provider: Partial<IProvider> | null;
    data: Paginated<IInternal>;
    month: { monthEnd: string; monthStart: string };
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const InternalTable: React.FunctionComponent<Props> = ({ month, data, provider }: Props) => {
    const [formColumn, setFormColumn] = useState<any>(false);
    const [popup, setPopup] = useState<boolean>(false);
    const [opened, setOpened] = useState(-5);
    const [openDrop, setOpenDrop] = useState<boolean>(false);
    const isMobile = window.innerWidth <= 800;
    const [currentAction] = useState<string>('SIGN');

    const dataSessionComponents: any = [];

    const entityModal: any = {};
    const { totalPages, page } = data;
    let totalAmount = 0;
    data.list.forEach((itSes: any) => {
        totalAmount += itSes.amount ? +itSes.amount : 0;
        if (`${formColumn}` === `${itSes['id']}`) {
            dataSessionComponents.push({
                ColumnForm: ColumnForm,
                setOpenDrop,
                month,
                providerId: provider?.id,
                ...itSes,
            });
            return false;
        }

        const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('InternalStatus') : {};
        const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);
        let valueStatus: any = statusItems.find((it) => it.value === itSes.status);
        valueStatus = valueStatus ? valueStatus.label : '';
        dataSessionComponents.push({
            ...itSes,

            action: (
                <div style={{ display: 'flex' }}>
                    {itSes.status !== 4 ? (
                        <div>
                            <button
                                className={classNames(styles.editBtn, 'btn btn-info')}
                                type={'button'}
                                onClick={() => setFormColumn(itSes['id'])}
                            >
                                <FontAwesomeIcon icon={faPencilAlt} />
                            </button>
                            <DeleteInternalAction data={{ id: itSes.id }} />
                        </div>
                    ) : null}
                </div>
            ),
            status: <div style={{ minWidth: 150, maxWidth: 150 }}>{valueStatus}</div>,
            amount: itSes.amount ? `$${numberWithCommas(itSes.amount)}` : '$0.00',
            internalDate: itSes.internalDate ? changeToZeroMoment(itSes['internalDate'], 'MMM D, YYYY') : '',
            startTime: itSes.startTime ? changeToZeroMoment(itSes['startTime'], 'LT') : '',
            endTime: itSes.endTime ? changeToZeroMoment(itSes['endTime'], 'LT') : '',
        });
    });
    if (formColumn === true) {
        if (isMobile) {
            dataSessionComponents.unshift({
                ColumnForm: ColumnForm,
                month,
                providerId: provider?.id,
                setOpenDrop,
            });
        } else {
            dataSessionComponents.push({
                ColumnForm: ColumnForm,
                month,
                providerId: provider?.id,
                setOpenDrop,
            });
        }
    } else {
        if (data.list.length) {
            dataSessionComponents.push({
                totalColumn: true,
                amount: `$${numberWithCommas(totalAmount)}`,
            });
        }
    }

    return (
        <div className={'d-flex flex-column'}>
            <div
                style={openDrop ? { overflow: 'visible' } : {}}
                className={classNames(styles.Table, 'responsive-table')}
            >
                {isMobile ? (
                    <MobileCard
                        type={'internal'}
                        action={(val) => {
                            setFormColumn(val);
                            if (!val) {
                                setOpened(-5);
                            }
                        }}
                        opened={opened}
                        setOpened={setOpened}
                        data={dataSessionComponents}
                        pagination={{ page, totalPages }}
                        columns={[
                            { id: 'action', label: 'Action', cellStyle: 'normal' },
                            { id: 'internalDate', label: 'Date', cellStyle: 'normal' },
                            { id: 'amount', label: 'Amount', cellStyle: 'normal' },
                            { id: 'description', label: 'Comment', cellStyle: 'normal' },
                            { id: 'status', label: 'Status', cellStyle: 'normal' },
                        ]}
                    />
                ) : (
                    <SimpleTable
                        action={setFormColumn}
                        data={dataSessionComponents}
                        pagination={{ page, totalPages }}
                        columns={[
                            { id: 'action', label: 'Action', cellStyle: 'normal' },
                            { id: 'internalDate', label: 'Date', cellStyle: 'normal' },
                            { id: 'amount', label: 'Amount', cellStyle: 'normal' },
                            { id: 'description', label: 'Comment', cellStyle: 'normal' },
                            { id: 'status', label: 'Status', cellStyle: 'normal' },
                        ]}
                    />
                )}

                <ModalComponent
                    modal={popup}
                    setModal={setPopup}
                    dataBody={entityModal[currentAction]?.body}
                    action={entityModal[currentAction]?.action}
                />

                <div className={'d-flex justify-content-end'}>
                    {user.getRoles().includes(UserRole.ROLE_ADMIN) && (
                        <button
                            className={'btn mr-1 ml-1 mb-2 btn-outline-info'}
                            type={'button'}
                            onClick={() => {
                                setOpened(0);
                                setFormColumn(true);
                            }}
                        >
                            <FontAwesomeIcon icon={faPlusCircle} />
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InternalTable;
